export default __webpack_public_path__ + "static/media/founder.16f724b6.jpg";